function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M6.251.875a5.408 5.408 0 00-3.697 1.428C1.57 3.221 1.01 4.468 1 5.773c0 3.684 5.251 9.102 5.251 9.102S11.5 9.472 11.5 5.773c-.01-1.304-.568-2.552-1.552-3.47A5.405 5.405 0 006.251.875z",
  stroke: "#333",
  strokeWidth: 1.5,
  strokeLinejoin: "round"
});

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 6.25,
  cy: 6.125,
  r: 2.25,
  stroke: "#333",
  strokeWidth: 1.5
});

function SvgPin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 13 16",
    fill: "none"
  }, props), _ref, _ref2);
}

export default SvgPin;